"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadSubdomains = exports.FetchSubdomains = exports.FetchSubdomainsActionTypes = exports.SubdomainsActionTypes = void 0;

var _fluxActions = require("flux-actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-lib/utils/namespacedKeyMirror"));

var _actions = require("settings-ui-lib/utils/actions");

var SubdomainsActionTypes = (0, _namespacedKeyMirror.default)({
  FETCH_SUBDOMAINS: null
}, 'analytics-and-tracking');
exports.SubdomainsActionTypes = SubdomainsActionTypes;
var FetchSubdomainsActionTypes = (0, _actions.createRequestTypes)(SubdomainsActionTypes.FETCH_SUBDOMAINS);
exports.FetchSubdomainsActionTypes = FetchSubdomainsActionTypes;
var FetchSubdomains = (0, _actions.createRequestActions)(FetchSubdomainsActionTypes);
exports.FetchSubdomains = FetchSubdomains;
var loadSubdomains = (0, _fluxActions.createAction)(SubdomainsActionTypes.FETCH_SUBDOMAINS, function (gates) {
  return {
    data: gates
  };
});
exports.loadSubdomains = loadSubdomains;